import { memo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorAlertBanner, HStack, Text } from '@library';
import useLoginState from '../../../core/hooks/useLoginState';
import type { ProductCustomerPrice, ProductWithRelatedData } from '../../types';
import ProductTilePricing from './ProductTilePricing';
import ProductTileActions from './ProductTileActions';
import { AddToCartConfirmationModal } from './AddToCartConfirmationModal';
import ProductInformation from './ProductInformation';
import styles from './ProductTile.module.scss';

const ProductTilePricingAndActions = ({
    product,
    selectedSKU: activeSKU,
    customerPrice,
    variantStartingPrice,
}: {
    product: ProductWithRelatedData;
    selectedSKU?: string;
    customerPrice?: ProductCustomerPrice;
    variantStartingPrice?: boolean;
}) => {
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const isLoggedIn = useLoginState();
    const { comment, vehicleComment } = product;

    if (!customerPrice || customerPrice.retailPrice === 0) {
        return (
            <div className={styles.errorBox}>
                <ErrorAlertBanner noBorder noPadding>
                    <Text secondary>
                        <FormattedMessage id="Price loading error" />
                    </Text>
                </ErrorAlertBanner>
            </div>
        );
    }

    return (
        <>
            <ProductTilePricing
                variantStartingPrice={variantStartingPrice}
                customerPrice={customerPrice}
                product={product}
                selectedSKU={activeSKU}
                divider={isLoggedIn}
            />
            <HStack align="end" justify="spaceBetween">
                <ProductInformation
                    comment={comment}
                    vehicleComment={vehicleComment}
                />
                <ProductTileActions activeSKU={activeSKU} />
            </HStack>
            {confirmationModalOpen && (
                <AddToCartConfirmationModal
                    setConfirmationModalOpen={setConfirmationModalOpen}
                />
            )}
        </>
    );
};

export default memo(ProductTilePricingAndActions);
